import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Banner } from '@app-model/oem-dealer';
import { OpenService } from '@app-services/open.service';
import { NgbCarousel, NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-vehicle-banners',
  templateUrl: './vehicle-banners.component.html',
  styleUrls: ['./vehicle-banners.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleBannersComponent implements OnInit {

  banners: Banner[];
  width = window.innerWidth;
  canSeeBanner: boolean;
  activeIndex = 0;
  private resumeAutoCycleAfterSlid = false;

  @Output("canSeeBanner") canSeeBannerEmitter = new EventEmitter<boolean>();
  @ViewChild('carousel') carousel: NgbCarousel;

  constructor(
    private openService: OpenService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.openService.getBanners().subscribe(banners => {
      if (banners && banners.length > 0) {
        this.banners = banners;
        this.canSeeBanner = true;
        this.activeIndex = 0;
      }

      this.canSeeBannerEmitter.emit(this.canSeeBanner);
      this.cdr.markForCheck();
    });
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = window.innerWidth;
  }

  getLink(url: string): void {
    window.open(url, "_self");
  }

  private pauseAndScheduleAutoCycleResume(): void {
    if (!this.carousel || !this.banners || this.banners.length < 2) return;
    this.resumeAutoCycleAfterSlid = true;
    // Pausa imediatamente para cancelar o tick que pode estar "na boca" de disparar
    this.carousel.pause();
  }

  previous(): void {
    this.pauseAndScheduleAutoCycleResume();
    this.carousel?.prev();
  }

  next(): void {
    this.pauseAndScheduleAutoCycleResume();
    this.carousel?.next();
  }

  selectBanner(index: number): void {
    if (index === this.activeIndex) return;
    this.pauseAndScheduleAutoCycleResume();
    this.carousel?.select(`banner-${index}`);
  }

  /** Dispara no INÍCIO da transição - atualiza o dot imediatamente */
  onSlide(event: NgbSlideEvent): void {
    if (!event?.current) return;
    const match = event.current.match(/^banner-(\d+)$/);
    if (!match) return;
    this.activeIndex = Number(match[1]);
    this.cdr.detectChanges();
  }

  /** Dispara no FINAL da transição - apenas retoma o autoplay */
  onSlid(_event: NgbSlideEvent): void {
    if (this.resumeAutoCycleAfterSlid) {
      this.resumeAutoCycleAfterSlid = false;
      this.carousel?.cycle();
    }
  }
}
